<div>
  <form [formGroup]="form">
    <div class="fields-container">
      <section>      
        <div class="field-control">
          <app-boolean
            [control]="form.get('isResident')"
            [options]="standardOption"
            [label]="'OWNER_FORM.RESIDENCY' | translate"
            [disabled]="!showAction"
          />
        </div>

        <!--  UAE-residents ONLY ------>
        @if ( form.get('isResident')?.value === fieldValue.YES || form.get('isResident')?.value === fieldValue.YES_AR &&
        form.get('partnerType')?.value == fieldValue.INDIVIDUAL ) {
        <div class="field-control">
          <app-text-field
            [control]="form.get('emiratesId')"
            [label]="'OWNER_FORM.EMIRATES_ID' | translate"
            [validationMessages]="{
              emiratesId: 'VALIDATION_MSG.VALID_EMIRATES_ID' | translate
            }"
          />
        </div>
        <div class="field-control">
          <!-- <label class="field-label">{{ "OWNER_FORM.DOB" | translate }}</label> -->
          <div class="field-control">
            <app-date
              [control]="form.get('emiratesDob')"
              [label]="'OWNER_FORM.DOB' | translate"
              [allowedDate]="'past'"
            />
          </div>
        </div>
        <div class="buttons-group">
          <app-button
            [type]="'button'"
            [label]="'BUTTONS.CHECK_DETAIL' | translate"
            classesName="card-edge-cut-white btn-edge-cut"
            (onBtnClick)="getDetailByEmirateId()"
          />
        </div>
        @if (loadingEmirateInfo) {
        <app-skeleton-loader [pingLoder]="true"></app-skeleton-loader>
        }
        <!-- if not detail found show message -->
        <div class="mb-2">
          @if (detailNotFound) {
          <app-validation-message
            [content]="{
              title: 'ALERT.NO_RESULTS_TITLE' | translate,
              message: 'ALERT.NO_RESULTS_DESC' | translate
            }"
            type="error"
          />
          }
        </div>
        }
        <!-- user detail if UAE Residend or Add My Self-->
        @if ( (detailFound && form.get('isResident')?.value === fieldValue.YES || form.get('isResident')?.value === fieldValue.YES_AR &&
        form.get('partnerType')?.value == fieldValue.INDIVIDUAL) ||
        form.get('typeOfAddUser')?.value === 'Myself' ) {
        <div class="mt-5 mb-5 space-y-4">
          <table class="w-full text-sm text-dc-navy">
            <tbody>
              <tr class="border-b">
                <td class="py-2 font-medium min-w-2xs">
                  {{ "OWNER_FORM.NAME_EN" | translate }}
                </td>
                <td class="py-2">
                  {{ form.get("nameEn")?.value }}
                </td>
              </tr>
              <tr class="border-b">
                <td class="py-2 font-medium min-w-2xs">
                  {{ "OWNER_FORM.NAME_AR" | translate }}
                </td>
                <td class="py-2">{{ form.get("nameAr")?.value }}</td>
              </tr>
              <tr class="border-b">
                <td class="py-2 font-medium">
                  {{ "OWNER_FORM.NATIONALITY" | translate }}
                </td>
                <td class="py-2">
                  @if (form.get("nationality")?.value) {
                  {{ form.get("nationality")?.value }}
                  } @else {
                  <app-option-field
                    [control]="form.get('nationality')"
                    [label]="''"
                    [country]="true"
                    [options]="countryList"
                    (onSelectionChange)="onNationalityChange($event)"
                  />
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        }

        <!-- NON-residents ONLY ----->
        @if ( form.get('isResident')?.value == fieldValue.NO ||
        form.get('isResident')?.value == fieldValue.NO_AR &&
        form.get('partnerType')?.value == fieldValue.INDIVIDUAL ) {
        <div class="field-control">
          <app-text-field
            [control]="form.get('passportNumber')"
            [label]="'OWNER_FORM.PASSPORT_NO' | translate"
            [maxlength]="30"
          />
        </div>
        <div class="field-control">
          <!-- <label class="field-label">{{
            "OWNER_FORM.PASSPORT_EXPIRY" | translate
          }}</label> -->
          <div class="field-control">
            <app-date
              [allowedDate]="'future'"
              [control]="form.get('passportExpiry')"
              [label]="'OWNER_FORM.PASSPORT_EXPIRY' | translate"
            />
          </div>
        </div>
        }

        <!-- INDIVIDUAL fields ---------->
        @if ( form.get('partnerType')?.value === fieldValue.INDIVIDUAL &&
        form.get('isResident')?.value != fieldValue.YES && form.get('isResident')?.value != fieldValue.YES_AR) {
        @if((form.get('typeOfAddUser')?.value == 'New profile' ||
        form.get('nameEn')?.invalid)){
        <div class="field-control">
          <app-text-field
            [control]="form.get('nameEn')"
            [label]="'OWNER_FORM.NAME_EN' | translate"
            [maxlength]="200"
            [validationMessages]="{
              english: 'VALIDATION_MSG.EN_LETTERS' | translate
            }"
          />
        </div>
        } @if((form.get('typeOfAddUser')?.value == 'New profile') ||
        (form.get('nameAr')?.invalid && (form.get('nameAr')?.touched ||
        form.get('nameAr')?.dirty))) {

        <div class="field-control">
          <app-text-field
            [control]="form.get('nameAr')"
            [label]="'OWNER_FORM.NAME_AR' | translate"
            [maxlength]="200"
            [validationMessages]="{
              arabic: 'VALIDATION_MSG.AR_LETTERS' | translate
            }"
          />
        </div>
        } @if((form.get('typeOfAddUser')?.value == 'New profile' ||
        form.get('nationality')?.invalid)){
        <div class="field-control">
          <app-option-field
            [control]="form.get('nationality')"
            [label]="'OWNER_FORM.NATIONALITY' | translate"
            [country]="true"
            [options]="countryList"
            (onSelectionChange)="onNationalityChange($event)"
          />
        </div>
        } }        

        <!----- OWNER / PARTNER EXCLUSIVE ----------->          
        @if ( (detailFound &&
        form.get('isResident')?.value == fieldValue.YES
        || form.get('isResident')?.value == fieldValue.YES_AR ) 
        || form.get('isResident')?.value == fieldValue.NO
        || form.get('isResident')?.value == fieldValue.NO_AR ) { 
            
        <!-- @if
        (form.get('roles')?.value?.includes('Shares Owner')) {
        <div class="field-control">
          <app-text-field
            type="number"
            [control]="form.get('share')"
            [label]="'OWNER_FORM.SHARE' | translate"
            [maxlength]="3"
          />
          <div class="mb-2">
            @if (showShareMsg) {
            <app-validation-message
              [content]="{
                title: 'ALERT.SHARE_MSG' | translate,
                message: 'ALERT.SHARE_FINAL_MSG_DESC' | translate
              }"
              type="error"
            />
            }
          </div>
        </div>
        } -->
        <div class="field-control">
          <app-mobile-number
            [label]="'OWNER_FORM.MOBILE' | translate"
            [control]="form.get('mobile')!"
            [countryCodeControl]="form.get('countryCode')!"
            [validationMessages]="{
              mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
              uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
            }"
          />
        </div>
        <div class="field-control">
          <app-text-field
            [control]="form.get('email')"
            [label]="'OWNER_FORM.EMAIL' | translate"
            [maxlength]="200"
            [validationMessages]="{
              email: 'VALIDATION_MSG.VALID_EMAIL' | translate
            }"
          />
        </div>
        } 
      </section>

      <!-- Attachments -->
      <section>
        @if ( form.get('isResident')?.value === 'No' ||
        form.get('partnerType')?.value === fieldValue.COMPANY ) {
        <h1 class="section-heading">
          {{ "UPLOAD_DOCUMENTS" | translate }}
        </h1>
        }
        @if(showAction){
          <app-validation-message
            [content]="{
              title: '',
              message: 'SIGNATORY_UPLOAD_NOTE' | translate
            }"
            type="info"
            [showbutton]="false"              
          />
        }
     
         @for (dt of partnerDocuments; track $index) {
            <div class="field-control">
               @if(dt.nameEn == 'Signature_Card'){
                <div class="document-template">
                    <i class="fas fa-file-download text-xl" aria-hidden="true"></i>
                    <div class="flex flex-col gap-1">
                      <span class="text-sm">{{'TEMPALTE_NOTE'| translate}}</span>
                      <a
                        class="font-semibold hover:text-dc-navy/80"
                        rel="noopener"
                        (click)="downloadTemplateFile()"
                        >{{'DOWNLOAD_TEMPLATE'| translate}} ({{lang == 'en' ? dt.nameEn : dt.nameAr}})</a
                      >
                    </div>
                  </div>
              }

              <app-file
                #fileCmp
                [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                [documentType]="dt.nameEn"
                (folderMissing)="folderMissing.emit()"
                (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                [showAction]="canUploadPartnerDocuments() && getNotesValue() !=''"
                [folder]="srFolder"
                [notes]="getNotesValue()"
                [documentServiceType]="documentServiceType.MEMBERSHIP"
              ></app-file>
            </div>
          }

        <div class="mb-2">          
          @if (showPassportOrSignatureMsg && form.get('partnerType')?.value == "Individual") {
            <app-validation-message
              [content]="{
                title: 'ALERT.ERROR' | translate,
                message: 'ALERT.UPLOAD_PASSPORT_SIGNATURECARD' | translate
              }"
              type="error"
            />
          }
          @if (showSameNameMsg) {
          <app-validation-message
            [content]="{
              title: 'ALERT.ERROR' | translate,
              message:
                'ALERT.USER_WITH_SAME_NAME'
                | translate
                  : {
                      name:
                        form.get('nameEn')?.value ||
                        form.get('companyNameEn')?.value
                    }
            }"
            type="error"
          />
          } @if(invalidFieldMsg){
          <div class="hidden">
            <app-validation-message
              [content]="{
                title: 'ALERT.ERROR' | translate,
                message: invalidFieldMsg
              }"
              type="error"
            />
          </div>
          }
        </div>
      </section>
      <!----- SUBMIT actions --------->
      <div class="buttons-group">
        @if(showAction){
        <app-button
          type="button"
          classesName="btn-edge-cut  btn-width-auto"
          [label]="'BUTTONS.ADD' | translate"
          (onBtnClick)="submitOwner()"
        />
        }
        <app-button
          type="button"
          classesName="card-edge-cut-white btn-width-auto"
          [label]="'BUTTONS.CLOSE' | translate"
          (onBtnClick)="close()"
        />
      </div>
    </div>
  </form>
</div>
